import { getSubdomain } from "@/utilities/domain"

interface ExportParams {
  startDate?: string
  endDate?: string
  reportType: string
  [key: string]: any
}

export const exportReport = async (params: ExportParams): Promise<boolean> => {
  try {
    // Convert camelCase keys to snake_case for API
    const apiParams: Record<string, any> = {}
    Object.entries(params).forEach(([key, value]) => {
      const snakeKey = key.replace(
        /[A-Z]/g,
        (letter) => `_${letter.toLowerCase()}`
      )
      apiParams[snakeKey] = value
    })

    const token = localStorage.getItem("token") ?? ""
    const subdomain = getSubdomain()
    const baseUrl = import.meta.env.VITE_BASE_URL

    const response = await fetch(`${baseUrl}/report/export`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "X-Tenant": subdomain,
      },
      body: JSON.stringify(apiParams),
    })

    // Handle non-stream errors (404 no data, 422 validation, 500 etc.)
    if (!response.ok) {
      if (response.status === 401) {
        console.error("Unauthorized. Please log in again.")
        return false
      }

      const err = await response.json().catch(() => ({}))
      console.error(err.message || "Failed to export report")
      return false
    }

    // Pull filename from Content-Disposition header
    const disposition = response.headers.get("Content-Disposition")
    const match = disposition?.match(/filename="?([^"]+)"?/)
    const rawFileName = match ? match[1] : "report.xlsx"
    const fileName = rawFileName.replace(/[/\\]/g, "_")

    // Download the streamed blob
    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)

    return true
  } catch (error) {
    console.error("Export error:", error)
    return false
  }
}
